﻿import { ColumnPickerDialog, Fluent, QuickSearchInput, stripDiacritics, trimToNull } from "@serenity-is/corelib";


const oldDialogOpen = ColumnPickerDialog.prototype["dialogOpen"];

const newDialogOpen = function (this: ColumnPickerDialog) {
    const input = QuickSearchInput.createDefaultElement();
    Fluent("div")
        .addClass("s-QuickSearchBar")
        .prependTo(this.element)
        .append(input);

    new QuickSearchInput({
        element: input,
        onSearch: (_fld, txt, done) => {
            txt = trimToNull(txt);
            if (txt != null)
                txt = stripDiacritics(txt.toLowerCase());

            this.element.findAll(".column-list").forEach((e) => {
                e.style.height = txt != null ? `${e.clientHeight}px` : "";
            });

            this.element.findAll('li').forEach((e) => {
                Fluent(e).toggle(!txt || stripDiacritics(
                    e.textContent!.toLowerCase()).indexOf(txt) >= 0);
            });
            done && done(true);
        }
    });

    oldDialogOpen!.call(this);
    this.element.closest(".s-ColumnPickerDialog").addClass("patched");
};

ColumnPickerDialog.prototype["dialogOpen"] = newDialogOpen;